import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Sale from '../../entities/cems/sale'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface SaleState extends ListState<Sale>{
    editModel: Sale;
    reportList: Array<any>;
    dealers: Array<any>;
    process: number;
    loadingDealers: boolean;
}
class SaleModule extends ListModule<SaleState,any,Sale>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Sale>(),
        loading:false,
        loadingDealers:false,
        editModel: new Sale(),
        activeList: new Array<Sale>(),
        reportList: new Array<any>(),
        dealers: new Array<any>(),
        process: null,
        path: 'sales'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async importData(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/sales/import',
                payload.data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.reportList = response.data.result;
            return true;
        },
        async updateBatch(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/sales/batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async processApiSales(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/sales-api', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async getDealers(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loadingDealers = true;
            let reponse = await Ajax.get('/api/sale-dealers', { params: payload.data }).catch(e => {
                context.state.loadingDealers = false;
                return Promise.reject(e);
            });
            context.state.loadingDealers = false;
            context.state.dealers = reponse.data.result;
        },
        async sendQuizRequest(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/sales-quiz-request', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: SaleState, model: Sale) {
            state.editModel = model;
            
        }, 
        new(state: SaleState, model: Sale) {
            state.editModel = Object.assign({});
        },
        setReportList(state: SaleState, list: Array<any>) {
            state.reportList = list;
        },
        setProcess(state: SaleState, value: number) {
            state.process = value;
        },
    });
}
const saleModule=new SaleModule();
export default saleModule;
